<template>
  <div class="scene">
    <flash-swf :attributes="attr" :flashvars="flashvars"></flash-swf>
  </div>
</template>

<script>
  // SceneSwf 组件
  import FlashSwf from '@/components/Flash/FlashSwf'

  // 通讯协议
  import protocol from '@/common/scripts/protocol.js'

  // 工具类
  import EUY from '@/common/scripts/euy.js'

  export default {
    components: {
      FlashSwf
    },
    data () {
      return {
        attr: {
          id: 'SCENE-SWF'
        },
        flashvars: {
          assetsUrl: process.env.SCENE_ASSETS_SWF
        }
      }
    },
    methods: {
      autoHeight() {

        let scene = document.querySelectorAll('.scene')

        EUY.autoHeight(scene, 0)

        // 改变浏览器窗口大小
        window.onresize = () => {
          EUY.autoHeight(scene, 0)
        }
      }
    },
    mounted () {
      // this.autoHeight()
    }
  }
</script>

<style lang="stylus">
  .scene
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
</style>



// WEBPACK FOOTER //
// Scene.vue?6db63e2a